import { Box, Grid } from '@mui/material'
import { Formik } from 'formik'
import React, { useEffect } from 'react'
import { useAcceptSettlementMutation } from '../../../../api/asset-holders/assetHolderApi'
import { type AssetHolderSettlementProps } from '../../../../api/schema-dtos/SettlementDomainDtos'
import {
  type SelectSettlementOptionPayloadDto,
  validateSettlementOptionPayload
} from '../../../../api/schema-dtos/SettlementPayloadDtos'
import { RtkQueryHelper } from '../../../../api/shared/RtkQueryHelper'
import { useAppDispatch } from '../../../../app/hooks'
import { useAuth } from '../../../auth/provider/AuthProvider'
import ErrorComponent from '../../../shared/components/ui-widgets/ErrorComponent'
import { setNotification } from '../../../shared/components/ui-widgets/uiWidgetsSlice'

export interface PortfolioSettlementFormProps extends AssetHolderSettlementProps {
  disabledInputs: boolean
}

const PortfolioSettlementForm: React.FC<AssetHolderSettlementProps> = ({ settlementDto }: AssetHolderSettlementProps) => {
  const { assetHolderId } = useAuth()
  const dispatch = useAppDispatch()
  const [apiAcceptSettlement, apiResult] = useAcceptSettlementMutation()
   
  const [_, setReopenForm] = React.useState(false)

  const defaultForm: SelectSettlementOptionPayloadDto = {
    assetHolderId,
    assetHolderSettlementId: settlementDto.assetHolderSettlementId,
    acceptedTermsAndIndemnity: settlementDto.accepted
  }

  const updateSettlementOnSubmit = async (values: SelectSettlementOptionPayloadDto): Promise<void> => {
    setReopenForm(false)
    await apiAcceptSettlement(values)
  }

  useEffect(() => {
    if (apiResult.isSuccess) {
      dispatch(setNotification({
        open: true,
        severity: 'success',
        message: 'Your Portfolio Settlement selection has been saved.'
      }))
    }

    if (apiResult.isError) {
      dispatch(setNotification({
        open: true,
        severity: 'error',
        message: RtkQueryHelper.mapResponseError(apiResult.error)
      }))
    }
  }, [apiResult.isSuccess, apiResult.isError])

  // const disabledInputs = (): boolean => {
  //   return settlementDto.isLocked || (settlementDto.isAmendable && !reopenForm)
  // }

  return (
    <>
      <Box>
        <Formik
          initialValues={defaultForm}
          validationSchema={validateSettlementOptionPayload}
          validateOnBlur={false}
          validateOnChange={false}
          onSubmit={async (values, actions) => {
            await updateSettlementOnSubmit(values)
          }}
        >
          {formikProps => (
            <form
              autoComplete={'off'}
              autoCorrect={'off'}
              onSubmit={formikProps.handleSubmit}
            >

              {!(formikProps.isValid) && (
                <Grid item md={12} sx={{ mt: 3 }}>
                  <ErrorComponent title={'Form validation error'}
                                  message={Object.values(formikProps.errors).join(' ')}/>
                </Grid>
              )}

               {/* <OptionSelectionConfirmation settlementDto={settlementDto} disabledInputs={disabledInputs()}/> */}

              {/* <Divider sx={{ mb: 2, mt: 2 }}/> */}

              {/* { settlementDto.accepted && ( */}
              {/*  <> */}
              {/*    <Typography variant={'body1'}> This settlement was accepted by {settlementDto.acceptedByEmail} on {settlementDto.acceptedAtFormatted}</Typography> */}
              {/*    <Alert severity="info" sx={{ mt: 3 }}> */}
              {/*      Please go to your &quot;My Wallets&quot; tab to setup your cash out instructions. */}
              {/*    </Alert> */}
              {/*  </> */}
              {/* )} */}

              {/* { !settlementDto.accepted && ( */}
              {/*  <Box display={'flex'} justifyContent={'space-between'}> */}
              {/*    <FormControl > */}
              {/*      <Button type="submit" variant={'contained'} disabled={disabledInputs()}> */}
              {/*        Submit */}
              {/*        /!* {(isLoading || fetchingAssetHolder) && <ButtonLoadingComponent/>} *!/ */}
              {/*      </Button> */}
              {/*    </FormControl> */}

              {/*    /!* <Box flexGrow={100}></Box> *!/ */}

              {/*    /!* {(settlementDto.isAmendable && ( *!/ */}
              {/*    /!*    <FormControl sx={{ mr: 2 }}> *!/ */}
              {/*    /!*      <Button variant={'outlined'} disabled={!settlementDto.isAmendable} onClick={handleReopenForm}> *!/ */}
              {/*    /!*        Edit your Settlement option *!/ */}
              {/*    /!*      </Button> *!/ */}
              {/*    /!*    </FormControl> *!/ */}
              {/*    /!* ))} *!/ */}
              {/*  </Box> */}
              {/* )} */}

            </form>
          )}

        </Formik>
      </Box>

    </>
  )
}

export default PortfolioSettlementForm
